import React, { useMemo } from 'react';

import { ReserveCapacityStore } from './store/reserve-capacity-store';
import { ReserveCapacityStoreProvider } from './store/store-context';
import { ReserveCapacityContent } from './reserve-capacity-content';

type Props = {
	teamId?: number;
	isNestedForm?: boolean;
};

export const ReserveCapacity: React.FC<Props> = ({ teamId, isNestedForm = false }) => {
	const store = useMemo(() => new ReserveCapacityStore(teamId), [teamId]);

	return (
		<ReserveCapacityStoreProvider value={store}>
			<ReserveCapacityContent isNestedForm={isNestedForm} />
		</ReserveCapacityStoreProvider>
	);
};
